import { render, staticRenderFns } from "./ChenillesUrticantes.vue?vue&type=template&id=0639ba74&"
import script from "./ChenillesUrticantes.vue?vue&type=script&lang=js&"
export * from "./ChenillesUrticantes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports